import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import WhatsAppButton from './components/feature/WhatsAppButton';
import ScrollToTopButton from './components/feature/ScrollToTopButton';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppButton />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;
